import { render, staticRenderFns } from "./Stratum.vue?vue&type=template&id=386959fe&scoped=true"
import script from "./Stratum.vue?vue&type=script&lang=js"
export * from "./Stratum.vue?vue&type=script&lang=js"
import style0 from "./Stratum.vue?vue&type=style&index=0&id=386959fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386959fe",
  null
  
)

export default component.exports